import { ERouterList } from '@internal/router/constants/router-list'

import InnerLayout from '@internal/layouts/inner-layout.vue'

import { auth } from '@internal/router/middleware/auth'

import { EUserRole } from '@shared/api/user-management/resources/user/constants/user-roles'

export const dcm = [
  {
    path: '/dcm',
    name: ERouterList.DCM,
    component: () => import('@internal/pages/dcm/index.vue'),
    meta: {
      middleware: [auth],
      middlewareRoleList: [EUserRole.PRACTICE_ADMIN, EUserRole.PRACTICE_CLINICIAN],
      layout: InnerLayout,
    },
  },
]

export default dcm
